import { AccountAttributesEnum } from '../enums';
import { Injectable } from '@angular/core';
import { RankingDataService } from '../../results/sidebar/services/ranking-data.service';
import { isEmpty, filter as lodashFilter, values as lodashValues, isObject } from 'lodash-es';
import { StateService } from '../../results/sidebar/services/us-states.service';
import { UserService } from '../../core/services/user.service';
import { LocationsService } from './locations.service';

@Injectable({
    providedIn: 'root'
})
export class CriteriaToRequestService {
    constructor(
        private RankingData: RankingDataService,
        private stateService: StateService,
        private readonly userService: UserService,
        private readonly locationsService: LocationsService
    ) { }

    transformArray(criteria, request, key) {
        key.forEach(element => {
            let list = [];
            if (typeof criteria[element] === 'string') {
                if (criteria[element] !== null && criteria[element] !== '') {
                    list.push(parseInt(criteria[element], 10));
                } else if (criteria[element] === null && criteria[element] === '') {
                    list.push(0);
                }
                request[element] = list;
            } else if (typeof criteria[element] === 'object') {
                list = criteria[element];
                request[element] = list;
            }
        });
        return request;
    }

    // universal contact location update
    transformArrayToString(criteria, request, key?, field?) {

        if (typeof criteria[key] === 'string') {
            request[key] = criteria[key];
        } else if(!field) {
            request[key] = criteria[key]?.join(',') || null;
        } else {
            request[key] = (criteria[key] || []).map(function (item) {
                return item[field];
            }).join(',');
            if (!request[key] || request[key] == '') {
                delete request[key];
            }
        }
        return request;
    }

    transformCopy(criteria, request, key) {
        key.forEach(element => {
            if (criteria[element] && criteria[element].length != 0) {
                const value = criteria[element];
                request[element] = value;
            }
        });
        if (request[key] && request[key].length === 0) {
            delete request[key];
        }

        if (request["specialties"] || request["specialties_any"] || request["specialties_all"] || request["specialties_none"]) {
            request = this.transformSpecialtiesData(request);
        }
        return request;
    }

    transformSpecialtiesData(request){
        if (request["specialties"] && request["specialties"].length === 0) {
            delete request["specialties"];
        }
        if (request["specialties_any"] || request["specialties_all"] || request["specialties_none"]) {
            if (request["specialties_any"] && request["specialties_any"].length > 0) {
                request["specialties_bool"] = {};
                request["specialties_bool"]["OR"] = request["specialties_any"];
            }
            delete request["specialties_any"];
            if (request["specialties_all"] && request["specialties_all"].length > 0) {
                if (isEmpty(request["specialties_bool"])) {
                    request["specialties_bool"] = {}
                }
                request["specialties_bool"]["AND"] = request["specialties_all"];
            }
            delete request["specialties_all"];
            if (request["specialties_none"] && request["specialties_none"].length > 0) {
                if (isEmpty(request["specialties_bool"])) {
                    request["specialties_bool"] = {}
                }
                request["specialties_bool"]["NOT"] = request["specialties_none"];
            }
            delete request["specialties_none"];
        }
        return request;
    }

    transformCopyWithZero(criteria, request, key) {
        key.forEach(element => {
            if (criteria[element] || criteria[element] === 0 || criteria[element] === '0') {
                const value = criteria[element];
                request[element] = value;
            }
        });
        return request;
    }

    transformArrayToCSV(criteria, request, key) {
        key.forEach(element => {
            if (element in criteria && criteria[element] && criteria[element].length > 0) {

                if (typeof criteria[element] === 'object') {
                    request[element] = criteria[element].join(',');
                } else {
                    request[element] = criteria[element];
                }
            }
        });
        return request;
    }

    transDefaultValueCountry(criteria, request, key) {
        if (criteria[key]) {
            request[key] = criteria[key];
            if (criteria[key].includes('UK') && !criteria[key].includes('GB')) {
                request[key].push('GB');
            }
            if (criteria[key].includes('GB') && !criteria[key].includes('UK')) {
                request[key].push('UK');
            }
        }
        if (key in request && (request[key].length === 0)) {
            delete request[key];
        }

        return request;
    }

    transformTiersCsv(criteria, request, key) {
        const tierValues = [];
        const tiers = criteria[key];
        tierValues.push(tiers);
        const tiersCsv = tierValues.join(',');

        if (tiersCsv.length > 0) {
            request[key] = tiersCsv;
        }
        return request;
    }

    transformRequiredFieldsCsv(criteria, request, key) {
        const requiredFields = criteria[key];
        const required = [];
        for (const keyId in requiredFields) {
            if (requiredFields[keyId] === true && keyId !== 'all') {
                required.push(keyId.toString());
            }
        }
        const requiredCsv = required.join(',');
        if (requiredCsv.length > 0) {
            request.required_fields_all = requiredCsv;
        }
        return request;
    }

    transformRankings(criteria, request, key) {
        const rankings = criteria[key];
        const selectedIds = [];
        for (const data in rankings) {
            if (rankings[data]) {
                selectedIds.push(data);
            }
        }
        const selectedTags = [];
        this.RankingData.getRankingData().forEach(item => {
            selectedIds.forEach(selectedId => {
                if (item.id === selectedId) {
                    selectedTags.push(item.tag);
                }
            });
        });
        request.company_tags = selectedTags;
        return request;
    }

    transformStringToArray(criteria, request, key) {
        key.forEach(element => {
            if (Array.isArray(criteria[element]) && criteria[element].length > 0) {
                request[element] = criteria[element];
            } else if (typeof criteria[element] === 'string' && criteria[element] !== '') {
                const resultArray = [];
                resultArray.push(criteria[element]);
                request[element] = resultArray;
            }
        });
        if (key in request && (request[key].length === 0)) {
            delete request[key];
        }

        if (!request["company_naics_codes"]?.length &&
            (request["company_naics_codes_any"]?.length || request["company_naics_codes_all"]?.length || request["company_naics_codes_none"]?.length)) {
            request = this.transformIndustryNaicsSicData(request, "company_naics_codes");
        }

        if (!request["company_sic_codes"]?.length &&
            (request["company_sic_codes_any"]?.length || request["company_sic_codes_all"]?.length || request["company_sic_codes_none"]?.length)) {
            request = this.transformIndustryNaicsSicData(request, "company_sic_codes");
        }


        return request;
    }

    transformIndustryNaicsSicData(request, data_type){
        if (request[data_type + "_any"] || request[data_type + "_all"] || request[data_type + "_none"]) {
            if (request[data_type + "_any"]) {
                request[data_type + "_bool"] = {};
                // request[data_type + "_bool"]["OR"] = request[data_type + "_any"][0].split(',');
                request[data_type + "_bool"]["OR"] = this.transformToArray(request[data_type + "_any"]);
            }
            delete request[data_type + "_any"];
            if (request[data_type + "_all"]) {
                if (isEmpty(request[data_type + "_bool"])) {
                    request[data_type + "_bool"] = {}
                }
                // request[data_type + "_bool"]["AND"] = request[data_type + "_all"][0].split(',');
                request[data_type + "_bool"]["AND"] = this.transformToArray(request[data_type + "_all"]);
            }
            delete request[data_type + "_all"];
            if (request[data_type + "_none"]) {
                if (isEmpty(request[data_type + "_bool"])) {
                    request[data_type + "_bool"] = {}
                }
                // request[data_type + "_bool"]["NOT"] = request[data_type + "_none"][0].split(',');
                request[data_type + "_bool"]["NOT"] = this.transformToArray(request[data_type + "_none"]);
            }
            delete request[data_type + "_none"];
        }
        return request;
    };

    transformToArray(prop: string | string[]): string[]{
        if (!prop) {
            return [];
        } else if (Array.isArray(prop)) {
            return prop.reduce((arr, cur) => [...arr, ...cur.split(',')], []);
        } else if (typeof prop === 'string') {
            return prop.split(',');
        }
        return [];
    }

    // 3952
    transformIfNotNull(criteria, request, key) {
        key.forEach(element => {
            if (criteria[element] !== null && criteria[element] !== '' && criteria[element] !== 0 && criteria[element] !== undefined) {
                const value = criteria[element];
                if (typeof value === 'string') {
                    request[element] = value ? value.trim() : value;
                } else {
                    request[element] = value;
                }
            }
        });
        return request;
    }

    transformCopyWithNull(criteria, request, key) {
        key.forEach(element => {
            if (criteria[element] || criteria[element] === 0 || criteria[element] === '0' || criteria[element] === null) {
                const value = criteria[element];
                request[element] = value;
            }
        });
        return request;
    }

    transformListArray(criteria, request, key) {
        key.forEach(element => {
            if (criteria[element]) {
                if (Array.isArray(criteria[element]) && criteria[element].length > 0) {
                    request[element] = criteria[element];
                } else if (criteria[element].length !== 0) {
                    const list = [];
                    list.push(parseInt(criteria[element], 10));
                    request[element] = list;
                }
            }
        });

        return request;
    }
    transformArraytoArray(criteria, request, key, field) {
        key.forEach(element => {
            const inputArray = criteria[element];
            if (inputArray) {
                const ListArray = [];
                inputArray.forEach((item) => {
                    if (item[field]) {
                        ListArray.push(item[field]);
                    } else {
                        ListArray.push(item);
                    }
                });
                request[element] = ListArray;
            }
        });

        return request;
    }
    transformObjectToArray(criteria, request, key) {
        const listArray = criteria[key] || [];
        if (Array.isArray(listArray) && listArray.length > 0) {
            const requestList = [];
            listArray.forEach((item) => {
                if (item['abbreviation']) {
                    lodashValues(item).forEach((innerItem) => {
                        requestList.push(innerItem);
                    });
                } else {
                    const stateArray = lodashFilter(this.stateService.getStateData(), (data) => {
                        return data['abbreviation'] === item;
                    });
                    stateArray.forEach((statItem) => {
                      lodashValues(statItem).forEach((innerItem) => {
                            requestList.push(innerItem);
                        });
                    });
                }
            });
            request[key] = requestList;
        }
        return request;
    }
    transformMapArrayToArray(criteria, request, key, field) {
        const resultArray = [];

        const inputArray = criteria[key] || [];
        if (Array.isArray(inputArray) && inputArray.length > 0) {
            inputArray.forEach((item) => {
                if (isObject(item)) {
                    const values = item[field];
                    if (Array.isArray(values)) {
                        values.forEach((value) => {
                            resultArray.push(value);
                        });
                    } else {
                        resultArray.push(values);
                    }
                } else {
                    resultArray.push(item);
                }
            });
        } else {
            if (inputArray.length > 0) {
                resultArray.push(criteria[key]);
            }
        }
        request[key] = resultArray;
        return request;
    }

    transformArrayToArray(criteria, request, key) {
        const resultArray = [];
        const inputArray = criteria[key] || [];
        inputArray.forEach((item) => {
            resultArray.push(item);
        });
        request[key] = resultArray;
        return request;
    }

    transformArrayCopy(criteria, request, key, field) {
        const resultArray = [];
        const inputArray = criteria[key] || [];
        inputArray.forEach((item) => {
            resultArray.push(item);
        });
        request[key] = resultArray;
        if (field !== '') {
            request[field] = resultArray;
        }
        return request;
    }

    transformTruthMapCsv(criteria, request, key) {
        key.forEach(element => {
            const truthMap = criteria[element];
            const trueCsv = this.joinTrueKeys(truthMap);
            if (trueCsv.length > 0) {
                request[element] = trueCsv;
            } else {
                delete request[element];
            }
        });

        return request;
    }
    joinTrueKeys(obj) {
        const trueKeys = [];
        for (const key in obj) {
            if (obj[key] === true) {
                trueKeys.push(key);
            }
        }
        return trueKeys.join(',');
    }

    transformJobTitle(criteria, request, key) {
        if (typeof criteria[key[0]] === 'string') {
            const jobTitle = criteria[key[0]].split(',').filter(item => item.trim().length > 0); // 4290
            request[key[0]] = jobTitle.toString().replace(/[\[\]']/g, '');
        }
        if (criteria[key[1]] || criteria[key[2]] || criteria[key[3]]) {
            request["job_title_bool"] = {};
            if (criteria[key[1]]) {
                const job_title_any = criteria[key[1]].split(',').filter(item => item.trim().length > 0);
                if (job_title_any.length > 0) {
                    request["job_title_bool"]["OR"] = job_title_any;
                }
            }
            if (criteria[key[2]]) {
                const job_title_all = criteria[key[2]].split(',').filter(item => item.trim().length > 0);
                if (job_title_all.length > 0) {
                    request["job_title_bool"]["AND"] = job_title_all;
                }
            }
            if (criteria[key[3]]) {
                const job_title_none = criteria[key[3]].split(',').filter(item => item.trim().length > 0);
                if (job_title_none.length > 0) {
                    request["job_title_bool"]["NOT"] = job_title_none;
                }
            }
        }
        return request;
    }
    transformCSVToArray(request, key) {
        key.forEach(element => {
            if (typeof request[element] === 'string' && request[element] !== '') {
                request[element] = request[element].split(',');
            }
        });
        return request;
    }

    transformBooleanArraytoArray(criteria, request, booleanKey) {
        booleanKey.forEach(element => {
            const inputArray = criteria[element];
            if (inputArray && inputArray.length != 0) {
                if (!request[element]) {
                    request[element] = {};
                }
                if (criteria[element + '_tab'] === 'ANY') {
                    request[element]['OR'] = criteria[element];
                } else if (criteria[element + '_tab'] === 'ALL') {
                    request[element]['AND'] = criteria[element];
                } else if (criteria[element + '_tab'] === 'NONE') {
                    request[element]['NOT'] = criteria[element];
                }
            }
        })
        return request;
    }

    transformAccuracyTiers(criteria, request, contactAccuracyTier, companyAccuracyTier) {
        if (!this.userService.hasAccess(AccountAttributesEnum.ACCURACYTIERS)) {
            return;
        }
        request[contactAccuracyTier] = criteria[contactAccuracyTier] || 'EV';
        request[companyAccuracyTier] = criteria[companyAccuracyTier] || 'MV';
        return request;
    }

    adjustFundingProperties(criteria: any, request: any) {
        if(criteria.min_funding_amount) {
            request.funding_type = criteria.funding_type;
            request.min_funding_amount_identifier = criteria.min_funding_amount_identifier;
        }
        if(criteria.max_funding_amount) {
            request.funding_type = criteria.funding_type;
            request.max_funding_amount_identifier = criteria.max_funding_amount_identifier;
        }
        return request;
    }

    adjustLocationProperties(request: any) {
        const locationCountryCodes = request.location_country_codes;
        const companyLocationStates = request.company_location_states;
        const contactLocationStates = request.contact_location_states;

        if (locationCountryCodes && locationCountryCodes.length === 1) {
            const countryCode = locationCountryCodes[0];
            const locations = this.locationsService.getLatestLocations();
            const country = locations.find(c => c.countryCode === countryCode);

            if (country) {
                const countryStates = country.states.map(state => state.stateCode);

                if (companyLocationStates) {
                    this.removeStatePropertyIfAllSelected(request, 'company_location_states', countryStates);
                }

                if (contactLocationStates) {
                    this.removeStatePropertyIfAllSelected(request, 'contact_location_states', countryStates);
                }
            }
        }
    }

    private removeStatePropertyIfAllSelected(request: any, propertyName: string, countryStates: string[]) {
        let states = request[propertyName];

        if (typeof states === 'string') {
            states = states.split(',').map(s => s.trim());
        }

        if (Array.isArray(states) && states.length > 0) {
            const allStatesSelected = countryStates.every(state => states.includes(state));

            if (allStatesSelected) {
                delete request[propertyName];
            }
        }
    }

}
